module.exports = __webpack_public_path__ + "img/21.d1f50c8c.jpg";